import React from 'react';

const EditGranularityContext = React.createContext({});

export const EDIT_GRANULARITY_ALL = 'All';
export const EDIT_GRANULARITY_OWNER = 'Owner';

export const EditGranularityProvider = ({ editGranularity, ...props }) => {
  return (
    <EditGranularityContext.Provider
      {...props}
      value={{ editGranularity, all: editGranularity === EDIT_GRANULARITY_ALL }}
    />
  );
};

export const useCanEdit = (section) => {
  const { editGranularity, all } = React.useContext(EditGranularityContext);
  return all || editGranularity.includes(section);
};
export const useCanEditAll = () => React.useContext(EditGranularityContext).all;

export default EditGranularityContext;
